module.exports = __webpack_public_path__ + "images/9337645707008fc3b99fadf2b61c79c5.png";